module.exports = __webpack_public_path__ + "img/SmallGuns.427690c2.png";